import React from 'react';
import { ChevronRight } from 'lucide-react';
import { colors, typography, radius, spacing } from '../../../theme';

/**
 * Concise chronological check-in list — replaces the old fully-expanded
 * gallery-per-row list. Tapping a row opens CheckInDetail via onSelectCheckIn.
 * props: { checkIns, onSelectCheckIn }
 */
const CheckInHistoryList = ({ checkIns, onSelectCheckIn }) => {
  const rows = (checkIns || []).filter(c => !c.is_onboarding).slice().reverse();
  if (rows.length === 0) return null;

  return (
    <div style={{ marginBottom: spacing.lg }}>
      <div style={{ ...typography.sectionHeading, color: colors.text, marginBottom: spacing.md }}>
        Check-In History
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing.sm }}>
        {rows.map((checkIn) => (
          <button
            key={checkIn.id}
            onClick={() => onSelectCheckIn(checkIn)}
            style={{
              display: 'flex', alignItems: 'center', gap: spacing.md,
              padding: spacing.md,
              background: colors.surface1,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.card,
              cursor: 'pointer', textAlign: 'left', width: '100%',
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: spacing.sm }}>
                <span style={{ ...typography.body, color: colors.text, fontWeight: '600' }}>
                  {new Date(checkIn.check_in_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
                {checkIn.bodyweight_kg && (
                  <span style={{ ...typography.body, color: colors.text, fontWeight: '600' }}>
                    {checkIn.bodyweight_kg} kg
                  </span>
                )}
              </div>
              <div style={{ ...typography.caption, color: colors.textMuted, marginTop: '2px' }}>
                Week {checkIn.week_number}
                {checkIn.message_to_coach ? ` • "${checkIn.message_to_coach.slice(0, 60)}${checkIn.message_to_coach.length > 60 ? '…' : ''}"` : ''}
              </div>
              {checkIn.photo_urls?.length > 0 && (
                <div style={{ ...typography.caption, color: colors.textSubtle, marginTop: '2px' }}>
                  {checkIn.photo_urls.length} photo{checkIn.photo_urls.length === 1 ? '' : 's'}
                </div>
              )}
            </div>
            <ChevronRight size={18} color={colors.textMuted} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default CheckInHistoryList;
